// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Material
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

// Custom
import SimpleBreadcrumbs from '../components/ui/SimpleBreadcrumbs';

// Data
const links = [{ name: 'About' }];

const useStyles = makeStyles(theme => ({
  page: {
    padding: theme.spacing(3, 2),
  },
  link: {
    textDecoration: 'none !important',
  },
}));

const About = () => {
  const classes = useStyles();
  const aboutUrl = 'https://www.naexguide.com/about';

  return (
    <React.Fragment>
      <Helmet>
        <title>About Naexguide | Search trains from Narita Airport</title>
        <meta property="og:url" content={aboutUrl} />
        <link rel="canonical" href={aboutUrl} />
      </Helmet>
      <Container>
        <SimpleBreadcrumbs links={links} />

        <Paper className={classes.page}>
          <h1>About Naexguide</h1>
          <p>Naexguide was built for travelers by travelers.</p>
          <p>
            When traveling to Japan, the last thing you want to worry about is
            how to get to and from the airport. That's why we have made it as
            easy as possible to find train times for the Narita Express.
          </p>
          <p>
            Looking to catch the Narita Express from Shinjuku, Shibuya, or Tokyo
            Station?
          </p>
          <p>
            Naexguide is your tool to find the trains you want when you need
            them.
          </p>
          <Link to="/" className={classes.link}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Search train times
            </Button>
          </Link>
        </Paper>
      </Container>
    </React.Fragment>
  );
};

export default About;
